import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "list" }
const _hoisted_2 = { class: "no-bullets" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "name" }

import { useStore } from 'vuex';
  import {onMounted, computed } from 'vue';
  import { ExternalFun } from '../../ExternalFun';
  import { TelegramClient } from "@/websocket/Client";
  // 定义接口 (类型)
  interface Session {
    id: number;
    user: {
      name: string;
      imgId: number;
    };
    messages: any[]; // 可以定义 MessageItem 类型
  }
  
  interface User {
    name: string;
    img: string;
  }
  
  // 使用 Composition API
  
export default /*@__PURE__*/_defineComponent({
  __name: 'list',
  setup(__props) {

  const store = useStore();
  const client = TelegramClient.getInstance();
  // 用户信息 (计算属性)
  const user = computed<User>(() => store.state.user);
  
  // 过滤后的会话列表 (计算属性)
  const sessions = computed<Session[]>(() => {
    const filterKey = store.state.filterKey;
    return store.state.sessions.filter((session: Session) =>
      session.user.name.includes(filterKey)
    );
  });

 
  
  // 当前会话 ID (计算属性)
  const currentId = computed<number>(() => store.state.currentSessionId);
  
  // 选择会话的函数
  const selectSession = async(id: number) => {
    console.log("selectSession="+id);
    store.commit('SELECT_SESSION', id);

    let session = store.state.sessions.find((item) => item.id === id);
    if (session) {
       if(session.messages.length > 0) return;
    }
    var senderName = store.state.user.name;
    const result = await client.getPrivateChatDataHistory(senderName, id,5);//必须发两条
    const response = await client.getPrivateChatDataHistory(senderName, id,30);
    let messages = response.messages;
    if(response.recipientPhone == senderName)
    { 
      if(messages && messages.length > 0)
      {
         for (let i = 0; i < messages.length; i++) {
           const element = messages[i];
           var senderId = element.senderId;
           var timestamp = element.timestamp * 1000;
           var content = element.content;
           var isSelf = true;
           if(senderId == id) isSelf = false;
           session.messages.push({
              content: content,
              date: new Date(timestamp),
              self: isSelf,
            });
         }   
      }

    }
 

  };

  const refreshReceiverList = async () => {
    console.log("refreshReceiverList");
    const username = localStorage.getItem("username");
    if (!username) {
      return;
    }
    var senderName = store.state.user.name;
    //const response = await client.getPrivateChatList(username, "session", 1);
    const response = await client.getPrivateChatData(senderName, "session",50);
    var msgList = response.messages;
    if (msgList && msgList.length > 0) {
      let list = msgList.map((receiver: any) => ({
        senderId: receiver.senderId,
        title:receiver.title,
      }));
      let receivers = list.filter((value) => value.senderId != "");
      for (let i = 0; i < receivers.length; i++) {
        const element = receivers[i];
        let session:Session = {
          id:element.senderId,
          user:{name:element.title,imgId:1},
          messages:[]
        };
        store.state.sessions.push(session);

      }
      selectSession(receivers[0].senderId);
      
    }

  }


  // WebSocket 消息监听
  onMounted(() => {
    store.state.sessions = [];
    localStorage.setItem('vue-chat-session', JSON.stringify(store.state.sessions));
    setTimeout(() => {
      refreshReceiverList();
        }, 500);
 
  });


  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sessions.value, (item) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item.id,
          class: _normalizeClass({ active: item.id === currentId.value }),
          onClick: ($event: any) => (selectSession(item.id))
        }, [
          _createElementVNode("img", {
            class: "avatar",
            width: "30",
            height: "30",
            src: _unref(ExternalFun).getImageUrl(item.user.imgId),
            style: {"display":"none"}
          }, null, 8, _hoisted_4),
          _createElementVNode("p", _hoisted_5, _toDisplayString(item.user.name), 1)
        ], 10, _hoisted_3))
      }), 128))
    ])
  ]))
}
}

})